import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox, FormControl, Text } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

import { InputControlProps } from '../../../@types';
import { createLogLocal } from '../../../utils/createLogLocal';

const log = createLogLocal('CheckboxControl.tsx');

export const CheckboxControl = React.forwardRef(
  (
    {
      name,
      label,
      helper,
      error,
      isDisabled,
      isRequired,
      rules,
      ...props
    }: InputControlProps,
    ref,
  ) => {
    const { register } = useFormContext();
    const { ref: inputRef, ...rest } = register(name, { ...rules });

    React.useImperativeHandle(ref, () => ({
      beforeSubmit() {
        log('CheckboxControl beforeSubmit does nothing.');
      },
    }));

    return (
      <FormControl
        isDisabled={isDisabled}
        isRequired={isRequired}
        className={cx('CheckboxContainer')}
        borderColor="transparent"
        sx={props.sx}
      >
        <Checkbox
          className={cx('Checkbox')}
          {...rest}
          ref={inputRef}
          isInvalid={!!error}
          isDisabled={isDisabled}
          isRequired={isRequired}
          onChange={(e: any) => {
            if (props.onChangeHandler) props.onChangeHandler(e.target.checked);
          }}
        >
          <Text color={error ? 'red' : ''}>{label}</Text>
        </Checkbox>
        {helper && !error && (
          <Text fontSize="sm" className={cx('CheckboxHelper')}>
            {helper}
          </Text>
        )}
        {error && typeof error === 'string' && (
          <Text fontSize="sm" color="red" className={cx('CheckboxError')}>
            {error}
          </Text>
        )}
      </FormControl>
    );
  },
);
